import * as DomBuilder from "./dom-builder.js";
import ComponentPanel from "./ComponentPanel.js";
import ServerPrivateAPI from "../ServerPrivateAPI.js";

/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */
export default class ComponentPanelPersistenceAPI extends ComponentPanel {

    /** @type {Controller} */
    #controller;

    /**
     *
     * @param controller {Controller}
     */
    constructor(controller) {
        super();
        this.#controller = controller;
    }

    getTabId() {
        return 'finance-tab-persistence-api';
    }

    getTabName() {
        return [DomBuilder.element("i", { class: "fa fa-floppy-o" }), DomBuilder.span(" Persistence")];
    }

    createNode() {
        return DomBuilder.div({ class: 'panel-persistence' }, [
            DomBuilder.bootstrapAlert('alert-info', [
                DomBuilder.par(null, "Datasets and filters are saved automatically.")
            ]),
            this.#createForceUpdateButton(), DomBuilder.element('br'),
            this.#createForceUpdateButtonIncremental(), DomBuilder.element('br'),
            this.#createExportButton()
        ]);
    }

    #createForceUpdateButton() {
        return DomBuilder.button('Update server data', { class: "btn btn-secondary" }, (e) => {
            this.updateServerData(false);
        });
    }

    #createForceUpdateButtonIncremental() {
        return DomBuilder.button('Update server data – incremental', { class: "btn btn-secondary" }, (e) => {
            this.updateServerData(true);
        });
    }

    updateServerData(incrementalUpdate) {
        let notificationProvider = this.#controller.getDataManager().getNotificationProvider();

        ServerPrivateAPI.updateServerData(incrementalUpdate).then(d => {
            notificationProvider.handleInfo('Info', 'Server data updated');
            this.#controller.getDataManager().load();
        }).catch(e => {
            notificationProvider.handleError('API call failed', e);
        });
    }

    #createExportButton() {
        return DomBuilder.button('Export', { class: 'btn btn-secondary' }, e => {
            this.#controller.getDataManager().exportAll();
        })
    }
}
